import { render } from "./ClientDetails.vue?vue&type=template&id=1e3fa525"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"

import "./ClientDetails.vue?vue&type=style&index=0&id=1e3fa525&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__